// prettier-ignore
//@ts-ignore
import { itemType } from 'MMT-UI/storages/client/localStorage';
// prettier-ignore
//@ts-ignore
import { getItemBySession,removeItemBySession,setItemBySession } from 'MMT-UI/storages/client/sessionStorage';
import { getUtilOptions } from ".";

/**
@param isEssential: Value should be true if it's a part of code functionality, else false if it's not core (eg:- third party or advertising related)
*/

// Note:- modifying options for backward compatibity in case of web, can remove this after commons release

const { ES, N_ES } = itemType;

function getEssentialItemType(isEssential: boolean) {
  return isEssential ? ES : N_ES;
}

// sesstion storage utils
export function setSessionStorageItem(
  key: string,
  value: any,
  isEssential = false,
  options: Record<string, string | boolean | number> | undefined = {
    shouldStringifyJson: true,
  }
) {
  options = getUtilOptions(options);
  setItemBySession(key, value, options, getEssentialItemType(isEssential));
}

export function getSessionStorageItem(
  key: string,
  isEssential = false,
  options: Record<string, string | boolean | number> | undefined = {
    shouldParseJson: true,
  }
): any {
  options = getUtilOptions(options);
  return getItemBySession(key, options, getEssentialItemType(isEssential));
}

export function removeSessionStorageItem(key: string) {
  removeItemBySession(key);
}
